import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { SkipMonthsListResults, MemberSkipMonthStats } from "../interface";
import { request } from "@/App/api/request";
import { AuthenticationContext, MemberEligibilityContext } from "@/App/context";

export const getEligibilityMemberSkipMonths = async (authToken: string) => {
  return request<{}, SkipMonthsListResults>({
    endpoint: "/eligibility/member_skip_month/list",
    body: {},
  }, authToken);
};

export const useGetEligibilityMemberSkipMonthsQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const { memberEligibility } = useContext(MemberEligibilityContext);

  return useQuery({
    queryFn: async () => {
      return getEligibilityMemberSkipMonths(await getAuthToken());
    },
    queryKey: ["getEligibilityMemberSkipMonths", memberEligibility.plan.id],
  });
};

export const getEligibilityMemberSkipMonthStats = async (authToken: string) => {
  return request<{}, MemberSkipMonthStats>({
    endpoint: "/eligibility/member_skip_month/stats",
    body: {},
  }, authToken);
};

export const useGetEligibilityMemberSkipMonthStatsQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const { memberEligibility } = useContext(MemberEligibilityContext);

  return useQuery({
    queryFn: async () => {
      return getEligibilityMemberSkipMonthStats(await getAuthToken());
    },
    queryKey: ["getEligibilityMemberSkipMonthStats", memberEligibility.plan.id],
  });
};
